var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.finishedAt)?_c('TimerLabel',{key:"timer-label",attrs:{"seconds":_vm.seconds}}):_c('TimerSeconds',{key:"timer-fixed",attrs:{"value":_vm.seconds}})
}
var staticRenderFns = []

export { render, staticRenderFns }